
import React, { useState } from 'react';
import SkillCard from './SkillCard';
import { skillsData } from './skillsData';
import SkillsDownloadCTA from './SkillsDownloadCTA';

const SkillsSection = () => {
  const [hoveredSkill, setHoveredSkill] = useState<string | null>(null);
  
  return (
    <>
      <section id="skills" className="py-16 px-6 bg-gradient-to-br from-sage-50 via-white to-warm-50">
        <div className="container max-w-5xl mx-auto">
          <div className="mb-12 text-center">
            <h2 className="text-sage-800 mb-2">Skills Snapshot</h2>
            <div className="w-24 h-1 bg-sage-300 mx-auto"></div>
            <p className="mt-4 text-sage-700 max-w-2xl mx-auto">
              A collection of abilities cultivated through education and experience
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {skillsData.map((skillGroup, index) => (
              <SkillCard 
                key={index}
                skillGroup={skillGroup}
                index={index}
                onHoverSkill={setHoveredSkill}
              />
            ))}
          </div>
        </div>
      </section>
      
      {/* Add the download CTA after the skills section */}
      <SkillsDownloadCTA />
    </>
  );
};

export default SkillsSection;
